<div class="demo-message-container" *ngIf="showDemoMessage | async">
    <div *ngIf="isAnonymousAccess" class="demo-message-inner fx-center-vertical" data-testid="signup-banner">
        <div class="demo-message-icon">
            <svg class="nu-icon nu-icon-med">
                <use xlink:href="./assets/icons/symbol-defs.svg#nu-ic-warning-fill"></use>
            </svg>
        </div>
        <div class="demo-message-text body">
            <span>
                {{translate.get( 'DEMO_MESSAGES.HEADER_MSG_PART1' )|async}}
            </span>
            <a
                [trackAction]="{ event: 'conversion.demo.banner.click'}"
                class="demo-message-auth-link btn-link body--bold"
                data-testid="signup-link"
                (click)="showAuthDialog()">
                {{translate.get( 'DEMO_MESSAGES.SINGING_UP')|async}}
            </a>
        </div>
    </div>
    <div *ngIf="!isAnonymousAccess" class="demo-message-inner fx-center-vertical" data-testid="signup-banner">
        <div class="demo-message-text body demo-message-text-container">
            <div *ngIf="hasDiagram">
                <span>
                    {{translate.get( 'DEMO_MESSAGES.HEADER_MSG_PART3' )|async}}
                </span>
            </div>
            <div>
                <span>
                    {{translate.get( 'DEMO_MESSAGES.HEADER_MSG_PART4' )|async}}
                </span>
                <a
                    [trackAction]="{ event: 'conversion.demo.banner.click'}"
                    class="demo-message-auth-link btn-link body--bold"
                    data-testid="signup-link"
                    (click)="showAuthDialog()">
                    {{translate.get( 'DEMO_MESSAGES.SINGING_UP')|async}}
                </a>
            </div>
        </div>
    </div>
</div>
